module.exports = __webpack_public_path__ + "static/media/iphone.5467ab80.png";